<template lang="pug" src="./slider-about-us-doctors.pug"></template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import Arrow from 'templates/smaller-arrow.icon.html'

export default {
  props: ['props'],
  data () {
    return {
      active: false,
      arrowNext: `<div class='slider-about-us-doctors__arrow slider-about-us-doctors__arrow--next'>${Arrow}</div>`,
      arrowPrev: `<div class='slider-about-us-doctors__arrow slider-about-us-doctors__arrow--prev'>${Arrow}</div>`
    }
  },
  components: {
    Carousel,
    Slide
  }
}
</script>



// WEBPACK FOOTER //
// slider-about-us-doctors.vue?926ea3a8